var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-context"},[_c('img',{staticClass:"banner",attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }